import type { CardHooks } from "./registry";

/**
 * Ignite Blade — to play, reveal a Quick attack/defend from hand (the
 * revealed card stays in hand — reveal is the play cost). For the rest of
 * the round, your Quick attacks deal +1 power and a Quick attack that deals
 * damage gives you +1 focus token.
 *
 * Implementation:
 *   • The reveal-precondition + reveal UI lives in playSig (playtestEngine).
 *   • The +1 power is a `quick-power-bonus` buff on `round-end` trigger —
 *     `round-end` is never matched by firePendingBuffs, so the buff is
 *     read by resolveCombat for every Quick attack and pruneBuffs drops it
 *     at the next round start.
 *   • The +1 focus on Quick-attack damage is gated to Quick attacks here.
 *     `onDamageDealt` is called for the Champion regardless of which
 *     attack just resolved — we only grant focus when that attack was Quick
 *     AND the controller has Ignite Blade active this round (the buff is
 *     present in pendingBuffs for the rest of the round).
 */
export const igniteBlade: CardHooks = {
  onAttackPlay: (ctx) => {
    return {
      selfPatch: {
        pendingBuffs: [
          ...ctx.self.pendingBuffs,
          {
            id: `ib_${Math.random().toString(36).slice(2, 9)}`,
            sourceCardName: "Ignite Blade",
            trigger: "round-end",
            effect: { kind: "quick-power-bonus", amount: 1 },
            createdRound: ctx.game.round,
          },
        ],
      },
      log: ["Ignite Blade — Quick attacks +1 power this round"],
    };
  },
};

